const submitRoiGateForm = require("../../run/roiCalculator/submitRoiGateForm");
const destroyRoiGateForm = require("../../run/roiCalculator/destroyRoiGateForm");
const convertRoiGateFormDataToUngatePayload = require("../../run/roiCalculator/convertRoiGateFormDataToUngatePayload");
const ungateRoiCalculatorForm = require("../../run/roiCalculator/ungateRoiCalculatorForm");

/**
 * @param form {HTMLFormElement}
 * @return {Promise<void>}
 */
module.exports = async function whenRoiGateFormSubmits(form) {
    const roiGateFormData = await submitRoiGateForm(form);

    if (roiGateFormData) {
        destroyRoiGateForm();

        const ungatePayload = convertRoiGateFormDataToUngatePayload(roiGateFormData);

        ungateRoiCalculatorForm(ungatePayload);
    }
}